import { Injectable } from '@angular/core';

import { Observable, from as observableFrom } from 'rxjs';
import { catchError, map, mergeMap, publishLast, refCount } from 'rxjs/operators';

import { ContextServiceBase } from '../baseBtl/context/context.service';

@Injectable({
    providedIn: 'root',
})
export class ContextService extends ContextServiceBase {
    public initContext(): Observable<ContextServiceBase> {
        return this.browseContextService.create().pipe(
            mergeMap((res) =>
                this.setContext(res).pipe(
                    catchError((e) => {
                        this.errorsContexts = this.errorsContexts.concat(e);
                        return observableFrom([this]);
                    }),
                    map(() => this),
                ),
            ),
            catchError((e) => {
                this.errorsContexts = this.errorsContexts.concat(e);
                console.error(this.errorsContexts);
                return observableFrom([this]);
            }),
            publishLast(),
            refCount(),
        );
    }
}
